export default "__VITE_ASSET__JkVGyms3__";